import IntegrationsTable from 'features/integrations/ui/IntegrationsTable/IntegrationsTable'

function AccountIntegrations() {
  return <IntegrationsTable />
}

export default AccountIntegrations
